module.exports = __webpack_public_path__ + "static/media/icon_down.93e41f75.svg";